var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { getFocusStyles, Shape, Spacing, withTheming, BorderWidth } from '@doordash/design-language';
import styled, { css } from 'styled-components';
import { sizeStyles } from './constants';
import { getTagPadding } from './utils';
export var IconButtonWrapper = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: none;\n  cursor: pointer;\n  user-select: none;\n  text-decoration: none;\n  text-align: center;\n  position: relative;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  &:focus {\n    ", "\n  }\n  > svg {\n    ", "\n  }\n"])), getFocusStyles(), function (props) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        height: ", "px;\n        width: ", "px;\n      "])), sizeStyles[props.size].iconSize, sizeStyles[props.size].iconSize);
});
export var IconWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  > svg {\n    ", "\n  }\n"])), function (props) {
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        height: ", "px;\n        width: ", "px;\n      "])), sizeStyles[props.size].iconSize, sizeStyles[props.size].iconSize);
});
export var TagWrapper = withTheming(styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", "px;\n  box-shadow: ", ";\n  display: inline-flex;\n  height: ", "px;\n  padding: ", ";\n  max-width: 100%;\n"])), function (props) {
  return function (_ref) {
    var theme = _ref.theme;
    return theme.Colors[props.backgroundColor];
  };
}, function (props) {
  return function (_ref2) {
    var theme = _ref2.theme;
    return theme.Shape.TagDefault === Shape.Pill ? theme.Size["Tag".concat(props.size)] * 2 : Spacing.XxxSmall;
  };
}, function (props) {
  return function (_ref3) {
    var theme = _ref3.theme;
    return "inset 0 0 0 ".concat(BorderWidth.Default, "px ").concat(theme.Colors[props.borderColor]);
  };
}, function (props) {
  return function (_ref4) {
    var theme = _ref4.theme;
    return theme.Size["Tag".concat(props.size)];
  };
}, function (props) {
  return getTagPadding(props);
}));